<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    <app-loading [condition]="isLoading.user"></app-loading>
    @if (!isLoading.user) {
      <div class="card border-0">
        <h4 class="card-header border-0">
          User <app-breadcrumb [menuItems]="menuItems" [currentContent]="currentContent"></app-breadcrumb>
        </h4>
        <div class="card-body pb-0">
          <div class="row row-cols-1 row-cols-lg-2">
            <div class="col mb-3 pr-lg-1">
              <app-user [user]="user"></app-user>
            </div>
            <div class="col mb-3">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title">Other info</h5>
                  @if (user.utopiaurl) {
                    <div class="mt-1">
                      <i class="fa fa-link fa-fw"></i> <a [href]="user.utopiaurl" target="_blank">View profile on UTOPIA website</a>
                    </div>
                  }
                  @if (user.driveurl) {
                    <div class="mt-1">
                      <i class="fa fa-folder me-1"></i> <a [href]="user.driveurl" target="_blank">Google Drive personal folder</a>
                    </div>
                  }
                  @if (auth.currentUser._id === id && !user.driveurl && !user.disabled) {
                    <div class="text-danger mt-1">
                      <i class="fa fa-folder me-1"></i> No Google Drive folder found, please add yours in <a routerLink="/account">Account settings</a>.
                    </div>
                  }
                  @if (auth.loggedIn && user._clients?.length < 100 && canViewTeamClients) {
                    <div class="mt-1">
                      <i class="fa fa-users"></i> Clients ({{user._clients.length}}):
                      @for (client of user._clients; track client; let last = $last) {
                        <span>
                          <a [routerLink]="'/client/' + client._id">{{client.name}}</a>@if (!last) {
                          <span>, </span>
                        }
                      </span>
                    }
                  </div>
                }
                @if (auth.loggedIn && user._clients?.length >= 100 && canViewTeamClients) {
                  <div>
                    <i class="fa fa-users"></i> Clients ({{user._clients.length}}): all clients
                  </div>
                }
                @if (auth.loggedIn && auth.isAdmin) {
                  <div>
                    <i class="fa fa-key"></i> Permissions: {{user.permissions.join(', ')}}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <div class="card border-0" [hidden]="currentContent !== 'track-record'">
    <h4 class="card-header border-0">
      Track record
    </h4>
    <div class="card-body">
      @if (!isLoading.records && records?.length) {
        <p>
          <span class="badge badge-primary">{{count}}</span> results found:
        </p>
      }
      @if (isLoading.records === false && records?.length === 0) {
        <p>
          Nothing found.
        </p>
      }
      @if (isLoading.records) {
        <p>
          <app-spinner [condition]="isLoading.records"></app-spinner>
        </p>
      }
      @if (records?.length) {
        <div class="row row-cols-1 row-cols-lg-2" [ngClass]="{ 'disabled': isLoading.records }">
          @for (record of records; track record) {
            <div class="col mb-3">
              <app-record [record]="record" [clients]="clients"></app-record>
            </div>
          }
        </div>
      }
      @if (records?.length) {
        <div>
          <app-pagination [isLoading]="isLoading.records" [count]="count" [perPage]="perPage" [page]="page" eventName="getRecords"></app-pagination>
          <app-spinner [condition]="isLoading.records"></app-spinner>
        </div>
      }
    </div>
  </div>
  <div class="card border-0" [hidden]="currentContent !== 'stats'">
    <h4 class="card-header border-0">
      Statistics
    </h4>
    <div class="card-body" [ngClass]="{ 'disabled': isLoading.stats }">
      @if (isLoading.stats) {
        <p>
          <app-spinner [condition]="isLoading.stats"></app-spinner>
        </p>
      }
      <div class="row">
        <div class="col-lg-8 mb-3">
          <div class="card">
            <h5 class="card-header border-0">
              Activities per month
            </h5>
            <div class="card-body d-flex flex-row justify-content-around">
              @if (!counters.months?.length) {
                <div>
                  Nothing found.
                </div>
              }
              @for (counter of counters.months; track counter) {
                <div class="text-center">
                  <h4>{{counter.count}}</h4>
                  {{counter.month}}
                </div>
              }
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Average
            </h5>
            <div class="card-body d-flex flex-row justify-content-around">
              <div class="text-center">
                <h4>{{counters.avg | number:'1.0-1'}}</h4>
                average per month
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Activities per week
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartWeek, 'activities_per_week')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart1"></canvas>
            </div>
          </div>
        </div>
        <div class="col-lg-5 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Activities per type
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartActivity, 'activities_per_type')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart2"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</div>

